import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Fade } from '@mui/material';
import classNames from 'classnames';

import { PredefinedMilisecondsTypeEnum } from '../../lib/enums';
import lang from '../../lib/language';
import { RootState } from '../../lib/store';

import NoWifi from '../../assets/img/no-wifi.svg';
import { useIsMobile } from '../../hooks';

import styles from './ConnectionStatusBar.module.scss';

const ConnectionStatusBar: FC = (): JSX.Element | null => {
  const { isMobile } = useIsMobile();
  const isOnline = useSelector<RootState, boolean>((state) => state.app.isOnline);
  const isConnectionSlow = useSelector<RootState, boolean>((state) => state.app.isConnectionSlow);
  const [isToastPrevented, setIsToastPrevented] = useState(false);
  const shouldShowBar = (!isOnline || isConnectionSlow) && !isToastPrevented;

  // Prevent blinking
  useEffect(() => {
    if (isToastPrevented) {
      const timer = setTimeout(() => {
        setIsToastPrevented(false);
      }, PredefinedMilisecondsTypeEnum.tenSeconds);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [isToastPrevented]);

  return (
    <Fade
      in={shouldShowBar}
      onExited={() => setIsToastPrevented(true)}
      timeout={PredefinedMilisecondsTypeEnum.twoSeconds}
    >
      <div
        className={classNames(styles.container, {
          [styles.containerMob]: isMobile,
          [styles.containerWeb]: !isMobile,
        })}
      >
        <div className={styles.content}>
          <img src={NoWifi} className={styles.icon} alt="" />
          <span className={styles.message}>{lang.commonPoorInternetConnection()}</span>
        </div>
      </div>
    </Fade>
  );
};

export default ConnectionStatusBar;
